<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
    [title]="editText"></love-it-modal-header>
  <div class="modal-body">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-3">
            <label
              class="required-label"
              for="lastName"
            >Nachname</label
            >
            <input
              [ngClass]="{
                    'is-invalid': submitted && formGroup.get('lastName')?.errors,
                  }"
              class="form-control"
              formControlName="lastName"
              id="lastName"
              type="text" />
            @if (submitted && formGroup.get("lastName")?.errors) {
              <div class="invalid-feedback">
                @if (formGroup.get("lastName")?.errors["required"]) {
                  <div>Nachname ist ein Pflichtfeld.</div>
                }
              </div>
            }
          </div>
          <div class="col-sm-3">
            <label
              class="required-label"
              for="firstName"
            >Vorname</label
            >
            <input
              [ngClass]="{
                    'is-invalid': submitted && formGroup.get('firstName')?.errors,
                  }"
              class="form-control"
              formControlName="firstName"
              id="firstName"
              type="text" />
            @if (submitted && formGroup.get("firstName")?.errors) {
              <div class="invalid-feedback">
                @if (formGroup.get("firstName")?.errors["required"]) {
                  <div>Vorname ist ein Pflichtfeld.</div>
                }
              </div>
            }
          </div>
          <div class="col-sm-6">
            <label
              class="required-label"
              for="officeIds"
            >Standorte</label
            >
            <ng-select
              [formControl]="formGroup.get('officeIds') | formControl"
              [items]="offices"
              bindLabel="name"
              bindValue="id"
              [multiple]="true"
              id="officeIds"
              [ngClass]="{
                    'is-invalid': submitted && formGroup.get('officeIds')?.errors,
                  }"></ng-select>
            @if (submitted && formGroup.get("officeIds")?.errors) {
              <div class="invalid-feedback">
                @if (formGroup.get("officeIds")?.errors["required"]) {
                  <div>Standorte ist ein Pflichtfeld.</div>
                }
              </div>
            }
          </div>
          @if (
            authService.currentUserValue?.role === UserRole.Admin ||
            authService.currentUserValue?.role === UserRole.Bueroleitung
            ) {
            <div class="col-sm-6">
              <label
                for="phone"
              >Telefon</label
              >
              <love-it-tel-input
                id="phone"
                [formControl]="getControl('phone')"
                [ngClass]="{
                      'is-invalid': submitted && getControl('phone')?.errors,
                    }"></love-it-tel-input>
            </div>
            <div class="col-sm-6">
              <label
                for="email"
              >E-Mail</label
              >
              <input
                [ngClass]="{
                      'is-invalid': submitted && formGroup.get('email')?.errors,
                    }"
                class="form-control"
                formControlName="email"
                id="email"
                type="email" />
              @if (submitted && getControl("email")?.errors) {
                <div class="invalid-feedback">
                  @if (getControl("email")?.errors["email"]) {
                    <div>Geben Sie eine gültige Email-Adresse ein.</div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <love-it-modal-buttons
      (onSubmit)="onSubmit($event)"
      [dirty]="formGroup.dirty"
      [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.Employee"></love-it-modal-buttons>
  </div>
</form>
